<div class="header-actions">
  <button color="primary" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="loader-container">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>

<div class="viewer-container">
  @switch (viewerType) {
    <!-- Image Viewer -->
    @case ('image') {
      <div class="image-container">
        <img [src]="safeUrl" alt="Document Preview" (load)="onLoad()" (error)="onLoad()" />
      </div>
    }
    <!-- PDF Viewer (Native) -->
    @case ('pdf') {
      <object [data]="safeUrl" type="application/pdf" class="pdf-viewer" (load)="onLoad()">
        <div class="pdf-fallback">
          <p>
            {{ 'ChunkFileDisplayer.PdfFallback' | translate }}
            <a [href]="safeUrl" download>{{ 'ChunkFileDisplayer.DownloadPdf' | translate }}</a>
          </p>
        </div>
      </object>
    }
  }
</div>
